export default __webpack_public_path__ + "static/media/mc.135acc66.png";